export var VERTEX_SHADER = 'vs';
export var FRAGMENT_SHADER = 'fs';
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@luma.gl/shadertools/dist/esm/lib/constants.js
// module id = 467
// module chunks = 0